import './App.css';
import GamePage from './components/GamePage';

function App() {
  return (
    <div className="App">
      <GamePage />
    </div>
  );
}

export default App;
